import React from 'react'
import Header from './Header'
import FullPageLoader from './FullPageLoader'
import { useSelector } from 'react-redux';
import Footer from './Footer';

export default function Layout({ children }) {
    const loading = useSelector(state => state.user.loading);
    const theme = useSelector((state) => state.user.theme);

    return (
        <div id="wrapper" className={`${theme === 'dark' ? 'dark-scheme' : ''}`}>
            {loading ? (
                <FullPageLoader loading={loading} />
            ) : (
                <>
                    <Header />
                    <main>{children}</main>
                    <Footer/>
                </>
            )}



        </div>
    )
}
